import DynamicFiltersBar from './DynamicFiltersBar'

export default DynamicFiltersBar
